import React from 'react';
import { connect } from 'react-redux';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../../redux/store';
import GridCellWrapper from '../../../../../components/grid-cell-wrapper/GridCellWrapper';
import {
  setTausch_A,
  setTausch_B,
  setTausch_R,
  setTausch_Y,
} from '../../../../../redux/actions/auftragserfassung';
import InputFieldText from '../../../../../components/input/floating-label/input-field/InputFieldText';

interface TauschgeraeteProps {
  auftragserfassung: StateModel_Auftragserfassung;
  setTausch_A: (value: string | undefined) => void;
  setTausch_B: (value: string | undefined) => void;
  setTausch_R: (value: string | undefined) => void;
  setTausch_Y: (value: string | undefined) => void;
}

/**
 * Component fuer die Tauschgeräte.
 *
 * @returns {JSX.Element}
 */
const Tauschgeraete = (props: TauschgeraeteProps) => {
  //  useEffect(() => {}, []);

  return (
    <GridCellWrapper classes='tauschgeraete' label='Tauschgeräte'>
      <div id='tausch'>
        <InputFieldText
          inputType='number'
          label='PA'
          tooltip={'Europalette'}
          classes='ta'
          onChangeHandler={props.setTausch_A}
          value={props.auftragserfassung.tauschpaletteA}
        />
        <InputFieldText
          inputType='number'
          label='TR'
          tooltip={'Tauschrahmen'}
          classes='tr'
          onChangeHandler={props.setTausch_R}
          value={props.auftragserfassung.tauschpaletteR}
        />
        <InputFieldText
          inputType='number'
          label='TB'
          tooltip={'Tauschbrett'}
          classes='tb'
          onChangeHandler={props.setTausch_B}
          value={props.auftragserfassung.tauschpaletteB}
        />
        <InputFieldText
          inputType='number'
          label='Y'
          tooltip={'Gitterboxpalette'}
          classes='y'
          onChangeHandler={props.setTausch_Y}
          value={props.auftragserfassung.tauschpaletteY}
        />
      </div>
    </GridCellWrapper>
  );
};
// zieht die Sachen aus dem redux State, damit sie hier benutzt werden können
const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
});

export default connect(mapStateToProps, {
  setTausch_A,
  setTausch_B,
  setTausch_R,
  setTausch_Y,
})(Tauschgeraete);
